<div class="modal-header" qaDependencyDrag>
  <div><h4 class="modal-title" id="qa-dependency-title">{{_('Bedingungen bearbeiten')}}</h4>
    <p class="qa-condition-intro">{{_('Legen Sie fest, wann diese Frage angezeigt wird.')}}</p></div>
  <button type="button" class="close" [attr.aria-label]="_(KEYS.EDITOR.CLOSE)" (click)="activeModal.dismiss()">&times;</button>
</div>
<div class="modal-body qa-condition-body">
  <div class="qa-condition-heading"><span class="qa-condition-badge">{{_('FRAGE ANZEIGEN')}}</span>
    <label *ngIf="group"><input type="checkbox" [(ngModel)]="advanced"> {{_('Weitere Optionen')}}</label></div>
  <ng-container *ngIf="group; else unsupported">
    <ng-container *ngTemplateOutlet="node; context: {$implicit: group}"></ng-container>
    <div class="qa-condition-preview" aria-live="polite">
      <span *ngIf="group.elements.length" class="qa-dependency-caption">{{_('Diese Frage anzeigen, wenn')}}</span>
      <app-qa-dependency-summary [group]="group" [sources]="sources" [compact]="true"></app-qa-dependency-summary>
    </div>
  </ng-container>
  <ng-template #unsupported>
    <div class="qa-dependency-warning" role="status">{{_('Dieser Ausdruck kann nicht verlustfrei im visuellen Editor bearbeitet werden.')}}
      {{_('Er bleibt unverändert. Sie können die Bedingungen entfernen und neu aufbauen.')}}</div>
  </ng-template>
  <details *ngIf="expression"><summary>{{_('Technischen Ausdruck anzeigen')}}</summary><code class="qa-condition-source">{{expression}}</code></details>
  <p *ngIf="validation" class="qa-condition-validation" role="status">{{_(validation)}}</p>
  <p class="qa-condition-help">{{_('Änderungen werden erst mit Übernehmen wirksam.')}}</p>
</div>
<div class="modal-footer">
  <button *ngIf="existing || (group && group.elements.length)" type="button" class="btn btn-outline-danger mr-auto"
          (click)="clear()">{{_('Bedingungen entfernen')}}</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{_(KEYS.EDITOR.TEXT_VARIABLE_CANCEL)}}</button>
  <button type="button" class="btn btn-primary" [disabled]="!!validation" (click)="save()">{{_(KEYS.EDITOR.CONDITION_APPLY)}}</button>
</div>

<ng-template #node let-group let-parent="parent" let-index="index">
  <div class="qa-condition-group">
    <div class="qa-condition-group-heading">
      <select class="form-control form-control-sm" [(ngModel)]="group.operator" [attr.aria-label]="_(KEYS.EDITOR.CONDITION_CONNECT)">
        <option value="&&">{{_('Alle Bedingungen müssen zutreffen')}}</option>
        <option value="||">{{_('Mindestens eine Bedingung muss zutreffen')}}</option>
      </select>
      <button *ngIf="parent" type="button" class="qa-condition-remove" (click)="remove(parent, index)"
              [attr.aria-label]="_(KEYS.EDITOR.CONDITION_REMOVE_GROUP)">&times;</button>
    </div>
    <div *ngFor="let child of group.elements; let i = index" class="qa-condition-child">
      <div *ngIf="i" class="qa-dependency-join">{{_(group.operator === '||' ? 'ODER' : 'UND')}}</div>
      <ng-container *ngIf="child.type === 'group'; else rule">
        <ng-container *ngTemplateOutlet="node; context: {$implicit: child, parent: group, index: i}"></ng-container>
      </ng-container>
      <ng-template #rule>
        <div class="qa-condition-rule" [class.qa-dependency-invalid]="child.variable && issue(child)">
          <div class="qa-condition-rule-main">
            <button type="button" class="qa-condition-variable" (click)="choose(child)"
                    [attr.aria-label]="name(child)" [attr.title]="name(child) + '\n' + child.variable">
              <i class="fa" [ngClass]="source(child)?.group === 'answers' ? 'fa-check-square-o' : 'fa-code'" aria-hidden="true"></i>
              <app-qa-dependency-source [source]="source(child)" [fallback]="name(child)"></app-qa-dependency-source>
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </button>
            <button type="button" class="qa-condition-remove" (click)="remove(group, i)"
                    [attr.aria-label]="_(KEYS.EDITOR.CONDITION_REMOVE_RULE)">&times;</button>
          </div>
          <div *ngIf="child.variable" class="qa-dependency-comparison">
            <select *ngIf="isAnswer(child); else comparison" class="form-control" [ngModel]="predicate(child)"
                    (ngModelChange)="setPredicate(child, $event)" [attr.aria-label]="_(KEYS.EDITOR.CONDITION_COMPARE)">
              <option value="==:true">{{_('ist ausgewählt')}}</option><option value="!=:true">{{_('ist nicht ausgewählt')}}</option>
              <option *ngIf="advanced || predicate(child) === '==:false'" value="==:false">{{_('ist ausdrücklich abgewählt')}}</option>
              <option *ngIf="advanced || predicate(child) === '!=:false'" value="!=:false">{{_('ist nicht ausdrücklich abgewählt')}}</option>
            </select>
            <ng-template #comparison>
              <select class="form-control" [(ngModel)]="child.operator" (ngModelChange)="changeOperator(child)" [attr.aria-label]="_(KEYS.EDITOR.CONDITION_COMPARE)">
                <option *ngFor="let operator of comparisons(child)" [value]="operator">{{_(operators[operator] || operator)}}</option>
              </select>
              <ng-container [ngSwitch]="type(child)">
                <select *ngSwitchCase="'boolean'" class="form-control" [(ngModel)]="child.value" [attr.aria-label]="_(KEYS.EDITOR.CONDITION_VALUE)">
                  <option [ngValue]="true">{{_(KEYS.EDITOR.CONDITION_YES)}}</option><option [ngValue]="false">{{_(KEYS.EDITOR.CONDITION_NO)}}</option>
                </select>
                <input *ngSwitchCase="'number'" type="number" step="any" class="form-control" [(ngModel)]="child.value"
                       [attr.aria-label]="_(KEYS.EDITOR.CONDITION_VALUE)" [placeholder]="_(KEYS.EDITOR.CONDITION_VALUE)">
                <input *ngSwitchCase="'date'" class="form-control" [type]="dateInput(child)"
                       [ngModel]="dateValue(child)" (ngModelChange)="setDate(child, $event)" [attr.aria-label]="_(KEYS.EDITOR.CONDITION_VALUE)">
                <ng-container *ngSwitchDefault>
                  <select *ngIf="source(child)?.choices?.length && child.operator !== '~'; else textValue" class="form-control"
                          [(ngModel)]="child.value" [attr.aria-label]="_(KEYS.EDITOR.CONDITION_VALUE)">
                    <option [ngValue]="child.value" hidden>{{child.value || _('Wert wählen')}}</option>
                    <option *ngFor="let option of source(child).choices" [ngValue]="option.value">{{option.label}}</option>
                  </select>
                  <ng-template #textValue><input type="text" class="form-control" [(ngModel)]="child.value"
                    [attr.aria-label]="_(KEYS.EDITOR.CONDITION_VALUE)" [placeholder]="_(KEYS.EDITOR.CONDITION_VALUE)"></ng-template>
                </ng-container>
              </ng-container>
            </ng-template>
          </div>
          <p *ngIf="child.operator === '~'" class="qa-condition-help">{{_('Regulärer Ausdruck, zum Beispiel ^ABC.')}}</p>
          <p *ngIf="child.variable && issue(child)" class="qa-dependency-warning" role="status">{{_(issue(child))}}</p>
        </div>
      </ng-template>
    </div>
    <p *ngIf="!group.elements.length" class="qa-dependency-empty">{{_(parent ? 'Bitte ergänzen oder entfernen Sie die leere Gruppe.' : 'Diese Frage wird immer angezeigt.')}}</p>
    <div class="qa-condition-actions">
      <button type="button" class="qa-condition-add" (click)="add(group)"><i class="fa fa-plus" aria-hidden="true"></i> {{_('Bedingung hinzufügen')}}</button>
      <button type="button" class="qa-condition-add" (click)="add(group, true)"><i class="fa fa-sitemap" aria-hidden="true"></i> {{_('Untergruppe hinzufügen')}}</button>
      <button *ngIf="group.elements.length" type="button" class="qa-condition-add" (click)="negate(group)" [disabled]="!canNegate(group)"
              [title]="_(canNegate(group) ? 'Kehrt die Bedingung um: aus UND wird ODER, aus gleich wird ungleich.' : 'Muster-Vergleiche können nicht negiert werden.')">
        <i class="fa fa-exchange" aria-hidden="true"></i> {{_(parent ? 'Gruppe negieren' : 'Bedingung negieren')}}</button>
    </div>
  </div>
</ng-template>
